export default __webpack_public_path__ + "images/4H.89d8d1d.png";